import React from "react";
import {
  Box,
  Paper,
  Typography,
  Stack,
  Divider,
  Button,
} from "@mui/material";

import {
  Check,
  Mail,
  Smartphone,
  Headphones,
  ArrowRight,
  ShoppingBag,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const order = {
    orderId: "ORD1234567890",
    orderDate: "25 Aug 2026, 11:30 AM",
    paymentMethod: "UPI",
    paymentStatus: "Paid",

    productName: "Myntra Gift Card",
    productType: "Voucher Value",
    productImage:
      "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/zOLDsdjs6TLMp6Dpj0T2LQrddsSPUVppMjIaGJWl.jpg",

    denomination: 1000,
    quantity: 1,
    totalPaid: 1000,
  };
const navigate = useNavigate();

  const money = (value) =>
    `₹${Number(value).toLocaleString("en-IN")}`;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(180deg, #f7fcf9 0%, #ffffff 45%)",
        px: { xs: 1.5, sm: 3, md: 4 },
        py: { xs: 3, md: 7 },
      }}
    >
      <Box
        sx={{
          maxWidth: 780,
          mx: "auto",
        }}
      >
        {/* ================= SUCCESS HEADER ================= */}

        <Box
          sx={{
            textAlign: "center",
            mb: { xs: 3, md: 4 },
          }}
        >
          {/* Success Icon */}
          <Box
            sx={{
              position: "relative",
              width: 82,
              height: 82,
              mx: "auto",
              mb: 2,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                background: "#dff7e8",
              }}
            />

            <Box
              sx={{
                position: "absolute",
                width: 64,
                height: 64,
                top: 9,
                left: 9,
                borderRadius: "50%",
                background: "#079447",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow:
                  "0 8px 22px rgba(7,148,71,0.22)",
              }}
            >
              <Check
                size={36}
                color="#fff"
                strokeWidth={3}
              />
            </Box>
          </Box>

          <Typography
            sx={{
              fontSize: { xs: 28, sm: 34 },
              fontWeight: 800,
              color: "#111827",
              letterSpacing: "-0.7px",
            }}
          >
            Thank You!
          </Typography>

          <Typography
            sx={{
              mt: 0.7,
              fontSize: { xs: 13, sm: 14 },
              fontWeight: 700,
              color: "#079447",
            }}
          >
            Payment successful
          </Typography>

          <Typography
            sx={{
              mt: 0.8,
              fontSize: 12,
              color: "#6b7280",
              lineHeight: 1.6,
            }}
          >
            Your order has been placed successfully.
            <br />
            Your gift card is ready for delivery.
          </Typography>
        </Box>

        {/* ================= PRODUCT CARD ================= */}

        <Paper
          elevation={0}
          sx={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            overflow: "hidden",
            boxShadow:
              "0 8px 30px rgba(17,24,39,0.05)",
          }}
        >
          {/* Card Header */}
          <Box
            sx={{
              px: { xs: 2, sm: 2.5 },
              py: 1.8,
              background:
                "linear-gradient(90deg, #f8fffa, #ffffff)",
              borderBottom: "1px solid #edf0ee",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: 1.5,
                  background: "#e7f7ed",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#079447",
                }}
              >
                <ShoppingBag size={17} />
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 800,
                    color: "#171717",
                  }}
                >
                  Your Product
                </Typography>

                <Typography
                  sx={{
                    fontSize: 10,
                    color: "#888",
                    mt: 0.15,
                  }}
                >
                  Order #{order.orderId}
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Product Content */}
          <Box
            sx={{
              p: { xs: 1.8, sm: 2.5 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: { xs: 1.2, sm: 1.5 },
                border: "1px solid #edf0ee",
                borderRadius: 2,
                background: "#fff",
              }}
            >
              {/* Product Image */}
              <Box
                sx={{
                  width: { xs: 68, sm: 82 },
                  height: { xs: 68, sm: 82 },
                  flexShrink: 0,
                  borderRadius: 1.8,
                  border: "1px solid #e5e7eb",
                  background: "#fafafa",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  src={order.productImage}
                  alt={order.productName}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>

              {/* Product Details */}
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: 12, sm: 14 },
                    fontWeight: 800,
                    color: "#171717",
                  }}
                >
                  {order.productName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 10.5,
                    color: "#777",
                    mt: 0.35,
                  }}
                >
                  {order.productType}
                </Typography>

                <Stack
                  direction="row"
                  spacing={0.8}
                  alignItems="center"
                  sx={{ mt: 1 }}
                >
                  <Box
                    sx={{
                      px: 1,
                      py: 0.45,
                      borderRadius: 1,
                      background: "#e8f8ee",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10.5,
                        fontWeight: 800,
                        color: "#079447",
                      }}
                    >
                      {money(order.denomination)}
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      fontSize: 10,
                      color: "#777",
                    }}
                  >
                    × {order.quantity}
                  </Typography>
                </Stack>
              </Box>

              {/* Amount */}
              <Box
                sx={{
                  textAlign: "right",
                  flexShrink: 0,
                }}
              >
                <Typography
                  sx={{
                    fontSize: 9.5,
                    color: "#888",
                    mb: 0.3,
                  }}
                >
                  Amount Paid
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: 15, sm: 17 },
                    fontWeight: 800,
                    color: "#111827",
                  }}
                >
                  {money(order.totalPaid)}
                </Typography>

                <Box
                  sx={{
                    display: "inline-flex",
                    mt: 0.5,
                    px: 0.8,
                    py: 0.25,
                    borderRadius: 0.8,
                    background: "#e8f8ee",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 8.5,
                      fontWeight: 700,
                      color: "#079447",
                    }}
                  >
                    PAID
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Paper>

        {/* ================= DELIVERY MESSAGE ================= */}

        <Paper
          elevation={0}
          sx={{
            mt: 2,
            p: { xs: 1.8, sm: 2 },
            borderRadius: 2.5,
            border: "1px solid #d9f0e2",
            background:
              "linear-gradient(135deg, #f0fbf5, #f8fdf9)",
          }}
        >
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
          >
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                flexShrink: 0,
                background: "#d9f4e3",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Mail
                size={21}
                color="#079447"
                strokeWidth={2}
              />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 800,
                  color: "#087b3d",
                }}
              >
                Your gift card has been sent!
              </Typography>

              <Typography
                sx={{
                  fontSize: 10.5,
                  color: "#5f6b64",
                  mt: 0.35,
                  lineHeight: 1.5,
                }}
              >
                We have sent your gift card to your email
                and mobile number.
              </Typography>

              <Typography
                sx={{
                  fontSize: 9.5,
                  color: "#8a938e",
                  mt: 0.2,
                }}
              >
                Please check your inbox and spam folder.
              </Typography>
            </Box>
          </Stack>
        </Paper>

        {/* ================= WHAT'S NEXT ================= */}

        <Paper
          elevation={0}
          sx={{
            mt: 2,
            p: { xs: 1.8, sm: 2.2 },
            borderRadius: 2.5,
            border: "1px solid #e5e7eb",
            background: "#fff",
          }}
        >
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 800,
              color: "#171717",
              mb: 2,
            }}
          >
            What’s Next?
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(3, 1fr)",
              },
            }}
          >
            <InfoItem
              icon={<Mail size={21} />}
              title="Check Your Email"
              text="Your gift card details have been sent to your email."
            />

            <InfoItem
              icon={<Smartphone size={21} />}
              title="Instant Delivery"
              text="Your gift card is delivered instantly."
              border
            />

            <InfoItem
              icon={<Headphones size={21} />}
              title="Need Help?"
              text="Our support team is here to help you."
              border
            />
          </Box>
        </Paper>

        {/* ================= BUTTONS ================= */}

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.2}
          justifyContent="center"
          sx={{
            mt: 2.5,
            mb: 2,
          }}
        >
          <Button
            variant="outlined"
            endIcon={<ArrowRight size={15} />}
            onClick={() => navigate("/profile/order")}

            sx={{
              minWidth: { xs: "100%", sm: 155 },
              height: 42,
              borderRadius: 1.5,
              textTransform: "none",
              fontSize: 11,
              fontWeight: 700,
              color: "#374151",
              borderColor: "#d1d5db",
              background: "#fff",
              "&:hover": {
                borderColor: "#9ca3af",
                background: "#f9fafb",
              },
            }}
          >
            View My Order
          </Button>

          <Button
            variant="contained"
            endIcon={<ArrowRight size={15} />}
            onClick={() => navigate("/")}

            sx={{
              minWidth: { xs: "100%", sm: 175 },
              height: 42,
              borderRadius: 1.5,
              textTransform: "none",
              fontSize: 11,
              fontWeight: 700,
              background: "#079447",
              boxShadow:
                "0 5px 14px rgba(7,148,71,0.18)",
              "&:hover": {
                background: "#067b3a",
                boxShadow:
                  "0 6px 16px rgba(7,148,71,0.22)",
              },
            }}
          >
            Continue Shopping
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

/* ================= INFO ITEM ================= */

const InfoItem = ({
  icon,
  title,
  text,
  border = false,
}) => {
  return (
    <Box
      sx={{
        px: { xs: 0, sm: 2 },
        py: { xs: 1.4, sm: 0.5 },

        borderLeft: {
          xs: "none",
          sm: border ? "1px solid #e5e7eb" : "none",
        },

        borderTop: {
          xs: border ? "1px solid #e5e7eb" : "none",
          sm: "none",
        },

        "&:first-of-type": {
          pl: { sm: 0 },
        },
      }}
    >
      <Stack
        direction="row"
        spacing={1.2}
        alignItems="flex-start"
      >
        <Box
          sx={{
            width: 38,
            height: 38,
            flexShrink: 0,
            borderRadius: 1.5,
            background: "#eef5ff",
            color: "#2864c7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: 10.5,
              fontWeight: 800,
              color: "#222",
              mb: 0.35,
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              fontSize: 9.5,
              color: "#777",
              lineHeight: 1.5,
            }}
          >
            {text}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default ThankYou;
